import { Component, OnInit } from "@angular/core";
import { RankingService } from "./ranking.service";
import { Observable } from "rxjs";
import { AngularFireStorage } from "@angular/fire/storage";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { municipios } from "../ubica-tu-diputado/municipios";
@Component({
  selector: "ranking",
  templateUrl: "./ranking.component.html",
  styleUrls: ["./ranking.component.scss"],
  providers: [RankingService],
})
export class RankingComponent implements OnInit {
  politicians: Observable<any[]>;
  bancadas: Observable<any[]>;
  commission: Observable<any[]>;
  districts: Observable<any[]>;
  paramFilterData: string;
  listMunicipalities: [];
  buttonDisabled: boolean;

  constructor(
    private modalService: NgbModal,
    private rankingService: RankingService,
    private storage: AngularFireStorage
  ) {}

  ngOnInit() {
    this.politicians = this.rankingService.getPolitician();
    this.buttonDisabled = false;
    this.bancadas = this.rankingService.getBancadas();
    this.commission = this.rankingService.getCommissions();
    this.districts = this.rankingService.getDistricts();

    this.cargarDatosTabla();
    this.cargarDataSelectBancada();
    this.cargarDataComisiones();
    this.cargarDataDistritos();
  }

  diputados: any[];
  diputadosRes: any[];
  bancadasList: any[];
  commissionsList: any[];
  districtsList: any[];
  filterStatus: boolean = false;

  sortDataName: false;
  sortDataAssistences: false;
  sortDataCommissionsAssistences: false;
  sortDataFullParticipation: false;
  sortDataInitiativesPresented: false;
  sortDataTransparency: false;
  sortDataInitiativesApproved: false;
  sortDataTotal: false;

  bancadaFilter: string = "";
  genderFilter: string = "";
  commissionFilter: string = "";
  electionFilter: string = "";
  districtFilter: number;
  municipaltyFilter: number;
  section: string = "";

  cargarDatosTabla() {
    this.diputados = [];
    this.listMunicipalities = municipios;
    this.politicians.forEach((poldata) => {
      this.diputados = poldata;
      this.diputadosRes = poldata;

      for (let i = 0; i < this.diputados.length; i++) {
        this.diputados[i].image_path = this.storage
          .ref(this.diputados[i].image_path)
          .getDownloadURL();
      }
    });
  }

  cargarDataSelectBancada() {
    this.bancadas.forEach((poldata) => {
      this.bancadasList = poldata;
    });
  }

  cargarDataComisiones() {
    this.commission.forEach((poldata) => {
      this.commissionsList = poldata;
    });
  }

  cargarDataDistritos() {
    this.districts.forEach((poldata) => {
      this.districtsList = poldata;
    });
  }

  sortDataNameP(active, name) {
    this.sortDataName = active;
    this.sortDataCommissionsAssistences = false;
    this.sortDataAssistences = false;
    const politicianOrderBy = this.sortData(this.sortDataName, name);
    this.diputados = politicianOrderBy;
  }

  sortDataAss(active, property) {
    this.sortDataAssistences = active;
    this.sortDataName = false;
    this.sortDataCommissionsAssistences = false;
    this.sortDataFullParticipation = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataAssistences,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataCommissionAss(active, property) {
    this.sortDataCommissionsAssistences = active;
    this.sortDataAssistences = false;
    this.sortDataName = false;
    this.sortDataFullParticipation = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataCommissionsAssistences,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataFullP(active, property) {
    this.sortDataFullParticipation = active;
    this.sortDataAssistences = false;
    this.sortDataName = false;
    this.sortDataCommissionsAssistences = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataFullParticipation,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataInitiativesP(active, property) {
    this.sortDataInitiativesPresented = active;
    this.sortDataAssistences = false;
    this.sortDataName = false;
    this.sortDataCommissionsAssistences = false;
    this.sortDataFullParticipation = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataInitiativesPresented,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataTrans(active, property) {
    this.sortDataTransparency = active;
    this.sortDataInitiativesPresented = false;
    this.sortDataAssistences = false;
    this.sortDataName = false;
    this.sortDataCommissionsAssistences = false;
    this.sortDataFullParticipation = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataTransparency,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataInitiativesA(active, property) {
    this.sortDataInitiativesApproved = active;
    this.sortDataTransparency = false;
    this.sortDataInitiativesPresented = false;
    this.sortDataAssistences = false;
    this.sortDataName = false;
    this.sortDataCommissionsAssistences = false;
    this.sortDataFullParticipation = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataInitiativesApproved,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataT(active, property) {
    this.sortDataTotal = active;
    this.sortDataInitiativesApproved = active;
    this.sortDataTransparency = false;
    this.sortDataInitiativesPresented = false;
    this.sortDataAssistences = false;
    this.sortDataName = false;
    this.sortDataCommissionsAssistences = false;
    this.sortDataFullParticipation = false;
    const politicianOrderBy = this.sortDataRanking(
      this.sortDataTotal,
      property
    );
    this.diputados = politicianOrderBy;
  }

  sortDataRanking(sortDataProperty, property) {
    let direction = sortDataProperty ? 1 : -1;
    let politicianOrderBy = this.diputados.sort((a, b) => {
      if (
        a.percentile_Indicators[property] < b.percentile_Indicators[property]
      ) {
        return -1 * direction;
      } else if (
        a.percentile_Indicators[property] > b.percentile_Indicators[property]
      ) {
        return 1 * direction;
      } else {
        return 0;
      }
    });

    return politicianOrderBy;
  }

  sortData(sortDataProperty, property) {
    let direction = sortDataProperty ? 1 : -1;
    let politicianOrderBy = this.diputados.sort((a, b) => {
      if (a[property] < b[property]) {
        return -1 * direction;
      } else if (a[property] > b[property]) {
        return 1 * direction;
      } else {
        return 0;
      }
    });

    return politicianOrderBy;
  }

  startFilter() {
    this.filterStatus = !this.filterStatus;
    this.buttonDisabled = true;
    if (this.paramFilterData == "Bancada") {
      const politician = this.filterDataPerParameter(
        "political_party",
        "value",
        this.bancadaFilter
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    } else if (this.paramFilterData == "Género") {
      const politician = this.filterDataPerParameter(
        "gender",
        "",
        this.genderFilter
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    } else if (this.paramFilterData == "Comisión") {
      const politician = this.filterDataPerParameter(
        "commission",
        "value",
        this.commissionFilter
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    } else if (this.paramFilterData == "Tipo de Representación") {
      const politician = this.filterDataPerParameter(
        "election",
        "",
        this.electionFilter
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    } else if (this.paramFilterData == "Distrito") {
      const politician = this.filterDataPerParameter(
        "district",
        "value",
        this.districtFilter
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    } else if (this.paramFilterData == "Municipio") {
      const politician = this.filterDataPerParameter(
        "district",
        "value",
        this.municipaltyFilter
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    } else {
      const politician = this.filterDataPerSección(
        this.section,
        "district",
        "value"
      );
      if (!politician.length) {
        alert("No se encontrarón resultados con este filtro ");
        return;
      }
      this.diputados = politician;
    }

    this.modalService.dismissAll();
  }

  filterDataPerParameter(param, param2, data) {
    let filterData;
    if (param2 !== "") {
      filterData = this.diputados.filter(
        (diputado) => diputado[`${param}`][`${param2}`] == data
      );
    } else {
      filterData = this.diputados.filter(
        (diputado) => diputado[`${param}`] == data
      );
    }
    return filterData;
  }

  filterDataPerSección(section, param, param2) {
    const district: any = this.districtsList.filter((distrito) =>
      distrito.sections.includes(section)
    );
    const politician = this.diputados.filter(
      (diputado) => diputado[`${param}`][`${param2}`] == district[0].id_district
    );
    return politician;
  }

  openurl = function (url) {
    window.open(url, "_blank"); // may alse try $window
  };

  open(content) {
    this.modalService.open(content, { ariaLabelledBy: "modal-basic-title" });
  }

  selectFilter(param) {
    this.paramFilterData = param;
  }

  selectOptionBancada(value) {
    this.bancadaFilter = value;
  }
  selectOptionGenero(value) {
    this.genderFilter = value;
  }

  selectOptionComision(value) {
    this.commissionFilter = value;
  }

  selectOptionRepresentacion(value) {
    this.electionFilter = value;
  }

  selectOptionDistrito(value) {
    this.districtFilter = value;
  }

  selectOptionMunicipio(value) {
    this.municipaltyFilter = value;
  }

  cancelFilter() {
    this.diputados = this.diputadosRes;
    this.filterStatus = false;
    this.buttonDisabled = false;
    this.paramFilterData = "";
    this.bancadaFilter = "";
    this.genderFilter = "";
    this.commissionFilter = "";
    this.electionFilter = "";
    this.districtFilter = 0;
    this.municipaltyFilter = 0;
    this.section = "";
  }
}
